import { Component, OnInit } from "@angular/core";
import { BlogService } from "src/app/services/blog.service";

@Component({
	selector: "app-health-styles",
	templateUrl: "./health-styles.component.html",
	styleUrls: ["./health-styles.component.css"]
})
export class HealthStylesComponent implements OnInit {
	healthStyles: any;
	categoryId: number = 77;

	constructor(private blogService: BlogService) { }

	ngOnInit(): void {
		this.all();
	}

	all() {
		this.blogService.byCategory(this.categoryId).subscribe((data: any) => {
			if (data.status === "OK") {
				this.healthStyles = data.data.posts;
			}
		});
	}

	getCategories(healthStyle: any) {
		let names = healthStyle.categories.map((p: any) => p.name);
		return names.join(', ');
	}
}
